import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { useAuth, fmtErr } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { Seo } from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.onboarded ? "/app" : "/onboarding");
    } catch (e2) {
      setErr(fmtErr(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("auth.welcomeBack")} subtitle={t("auth.loginSubtitle")}
      footer={<>{t("auth.noAccount")} <Link to="/register" className="font-semibold text-primary">{t("auth.startFree")}</Link></>}>
      <Seo title="Log in" />
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label={t("auth.email")} type="email" value={email} onChange={setEmail} testid="login-email" />
        <Field label={t("auth.password")} type="password" value={password} onChange={setPassword} testid="login-password" />
        {err && <p className="text-sm text-bearish" data-testid="login-error">{err}</p>}
        <button disabled={loading} data-testid="login-submit" className="w-full rounded-xl bg-primary py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-60">
          {loading ? t("auth.signingIn") : t("auth.login")}
        </button>
      </form>
      <div className="mt-3 text-right"><Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-foreground">{t("auth.forgotPassword")}</Link></div>
      <div className="mt-5 rounded-lg border border-border bg-secondary/40 p-3 text-xs text-muted-foreground">
        Demo login — <span className="font-mono">demo@kreonis.ai</span> / <span className="font-mono">Demo@12345</span>
      </div>
    </AuthShell>
  );
}

export function Field({ label, type = "text", value, onChange, testid, placeholder }) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium">{label}</label>
      <input type={type} value={value} placeholder={placeholder} onChange={(e) => onChange(e.target.value)} required data-testid={testid}
        className="w-full rounded-xl border border-border bg-card px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-primary" />
    </div>
  );
}
